import { GridColDef, GridValidRowModel, getGridBooleanOperators } from '@mui/x-data-grid-premium'
import { CheckboxCell } from '../../data-grid/CheckboxCell'
import { BaseColumnConfig } from '../types'
import { transformBooleanOption } from '../utils/booleanFilterUtils'
import { baseColumnConfig } from './baseColumnConfig'

export type CheckboxColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'checkbox'> & {
  columnType: 'checkbox'
  onChange: (id: string, value: boolean) => void
}

export const getCheckboxColumn = <T extends GridValidRowModel>({
  columnType,
  style,
  onChange,
  ...config
}: CheckboxColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  type: 'boolean',
  // Use only the 'is' operator for boolean filtering (not 'isAnyOf')
  filterOperators: getGridBooleanOperators()
    .filter((operator) => operator.value === 'is')
    .map((operator) => ({
      ...operator,
      InputComponentProps: {
        ...operator.InputComponentProps,
        // Transform the valueOptions to use actual booleans (case-insensitive)
        valueOptions: operator.InputComponentProps?.valueOptions?.map(transformBooleanOption),
      },
    })),
  renderCell: (params) => <CheckboxCell {...params} onChange={onChange} checked={params.value} />,
})
